import {
    DatatableFilter,
    FilterControlType
} from '@common/datatable/datatable-filters/search-input-with-filters/filter-config/datatable-filter';
import { TrackingPixelTypes } from '../tracking-pixel-types';
import {
    CreatedAtFilter,
    UpdatedAtFilter
} from '@common/datatable/datatable-filters/search-input-with-filters/filter-config/timestamp-filter';
import { FindUserModalComponent } from '@common/auth/find-user-modal/find-user-modal.component';


export const TRACKING_PIXEL_FILTERS: DatatableFilter[] = [
    new DatatableFilter({
        type: FilterControlType.Select,
        key: 'type',
        defaultValue: 'facebook',
        description: 'Tracking pixel type',
        options: TrackingPixelTypes.map(pixel => {
            return {key: pixel.name, value: pixel.name};
        }),
    }),
    new CreatedAtFilter({
        description: 'Date pixel was created',
    }),
    new UpdatedAtFilter({
        description: 'Date pixel was last updated',
    }),
    new DatatableFilter({
        type: FilterControlType.SelectModel,
        key: 'user_id',
        label: 'User',
        description: 'User overlay was created by',
        component: FindUserModalComponent,
    }),
];
